export default "__VITE_ASSET__Dt3VCbrg__"